//LOGO
export const LOGO = '/assets/images/logo.png'

export const BRAND_LOGO = '/assets/svg/logo.svg'

//SITE NAME
export const SITE_NAME = 'Bond Roberts'

export const HEADER_SIDE_PANEL = []

// SIDE PANEL LIST
export const SIDE_PANEL = [
    // {
    //     label: 'Cigars',
    //     path: '/cigars',
    //     type: 'single',
    // },
    {
        label: 'Dashboard',
        path: '/dashboard',
        type: 'single',
    },
    {
        label: 'Users',
        path: 'users',
        type: 'multiple',
        subLinks: [
            {
                label: 'Add User',
                path: '/adduser',
            },
            {
                label: 'All Users ',
                path: '/users/all',
            },
            {
                label: 'Active Users',
                path: '/users/active',
            },
            // {
            //     label: 'Unverified Users',
            //     path: '/users/unverified',
            // },
            {
                label: 'Deactivated Users',
                path: '/users/deactivated',
            },
            {
                label: 'Suspended Users',
                path: '/users/deactivate',
            },
            {
                label: 'Rejected users',
                path: '/users/rejected',
            },
            {
                label: 'Waiting Admin Approve',
                path: '/users/unverified',
            },
        ],
    },
    // {
    //     label: 'Add Product',
    //     type: 'multiple',
    //     path: 'addproduct',
    //     subLinks: [
    //         {
    //             label: 'New Product',
    //             path: '/add/product',
    //         },
    //     ],
    // },

    {
        label: 'Events',
        path: 'auction',
        type: 'multiple',
        subLinks: [
            {
                label: 'Active',
                path: '/auction/open',
            },
            {
                label: 'Upcoming',
                path: '/auction/upcomming',
            },
            {
                label: 'Draft',
                path: '/auction/draft',
            },
            {
                label: 'Past',
                path: '/auction/closed',
            },
        ],
    },

    {
        label: 'Product',
        type: 'multiple',
        path: 'listing',
        subLinks: [
            {
                label: 'New Product',
                path: '/add/product',
            },
            {
                label: 'All',
                path: '/listing/all',
                // showCount: true,
                // count_name: 'activeCount',
            },
            {
                label: 'Active',
                path: '/listing/open',
                showCount: true,
                count_name: 'activeCount',
            },
            {
                label: 'Sold',
                path: '/listing/sold',
                showCount: true,
                count_name: 'soldCount',
            },
            {
                label: 'Unsold',
                path: '/listing/unsold',
                showCount: true,
                count_name: 'unsoldCount',
            },
            {
                label: 'Moderate',
                path: '/listing/draft',
                showCount: true,
                count_name: 'draftCount',
            },
            {
                label: 'Event',
                path: '/listing/event',
                showCount: true,
                count_name: 'eventCount',
            },
            {
                label: 'Escalate',
                path: '/listing/escalate',
                showCount: true,
                count_name: 'escalateCount',
            },

            {
                label: 'Relisted',
                path: '/listing/relisted',
                showCount: true,
                count_name: 'relistCount',
            },
        ],
    },

    {
        label: 'Invoice',
        path: 'invoice',
        type: 'multiple',
        subLinks: [
            {
                label: 'All',
                path: '/invoice/all',
            },
            {
                label: 'Unpaid',
                path: '/invoice/unpaid',
            },
            {
                label: 'Paid',
                path: '/invoice/paid',
            },
            {
                label: 'Partial',
                path: '/invoice/draft',
            },
            {
                label: 'Expired',
                path: '/invoice/expired',
            },
            {
                label: 'Cancel',
                path: '/invoice/cancel',
            },
        ],
    },
    // {
    //     label: 'Users',
    //     path: 'users',
    //     type: 'multiple',
    //     subLinks: [
    //         {
    //             label: 'Add User',
    //             path: '/adduser',
    //         },
    //         {
    //             label: 'All Users ',
    //             path: '/users/all',
    //         },
    //         {
    //             label: 'Active Users',
    //             path: '/users/active',
    //         },
    //         {
    //             label: 'Unverified Users',
    //             path: '/users/unverified',
    //         },
    //         {
    //             label: 'Deactivated Users',
    //             path: '/users/deactivate',
    //         },
    //         {
    //             label: 'Rejected users',
    //             path: '/users/rejected',
    //         },
    //     ],
    // },
    {
        label: 'Seller',
        path: 'org',
        type: 'multiple',
        subLinks: [
            {
                label: 'All Sellers',
                path: '/org/all',
            },
            {
                label: 'Active',
                path: '/org/active',
            },
            {
                label: 'Deactivated',
                path: '/org/deactivate',
            },
            {
                label: 'Suspended',
                path: '/org/suspended',
            },
            {
                label: 'Rejected',
                path: '/org/rejected',
            },
            {
                label: 'Awaiting Admin Approval',
                path: '/org/unverified',
            },
        ],
    },

    {
        label: 'Analytics',
        path: 'report',
        type: 'multiple',
        subLinks: [
            {
                label: 'Report',
                path: '/report',
                type: 'single',
            },
        ],
    },
    // {
    //     label: 'Marketing',
    //     path: 'campaign',
    //     type: 'multiple',
    //     subLinks: [
    //         {
    //             label: 'Create Campaign ',
    //             path: '/campaign/create',
    //         },
    //         {
    //             label: 'Email template',
    //             path: '/campaign/template',
    //         },
    //     ],
    // },
    {
        label: 'Communications',
        path: 'communications',
        type: 'multiple',
        subLinks: [
            {
                label: 'Email Template',
                path: '/communications/email',
            },
            // {
            //     label: 'SMS Template',
            //     path: '/communications/sms',
            // },
        ],
    },

    // {
    //     label: 'Plugins',
    //     path: '/plugins',
    //     type: 'single',
    // },

    {
        label: 'Management',
        path: 'management',
        type: 'multiple',
        subLinks: [
            {
                label: 'Cigar Source',
                path: '/management/source',
            },
            {
                label: 'Review',
                path: '/management/review',
            },
        ],
    },
    // {
    //     label: 'Pages',
    //     path: 'pages',
    //     type: 'multiple',
    //     subLinks: [
    //         {
    //             label: 'Pages',
    //             path: '/pages/static',
    //         },
    //     ],
    // },
    {
        label: 'Dispute',
        path: '/disputes',
        type: 'single',
    },
    {
        label: 'DB Uploads',
        path: 'db',
        type: 'multiple',
        subLinks: [
            {
                label: 'Country',
                path: '/db/country',
            },
            {
                label: 'Cigars',
                path: '/db/cigars',
            },
            {
                label: 'Serial Number',
                path: '/db/serial_number',
            },
            {
                label: 'Factory Code',
                path: '/db/factory_code',
            },
            {
                label: 'Disapproval Reason List',
                path: '/db/disapproval_reason',
            },
            {
                label: 'Payment File',
                path: '/db/payment_file',
            },
        ],
    },

    {
        label: 'Withdrawal Request',
        path: '/withdrawal_request',
        type: 'single',
    },
    {
        label: 'Configuration',
        path: '/site_configuration',
        type: 'single',
    },
    // {
    //     label: 'Currency Configuration',
    //     path: '/currency_configuration',
    //     type: 'single',
    // },
    {
        label: 'Currency Configuration',
        path: '/fixed_rate',
        type: 'single',
    },

    {
        label: 'Settings',
        path: 'settings',
        type: 'multiple',
        subLinks: [
            {
                label: 'Banner Image',
                path: '/settings/banner',
            },
            // {
            //     label: 'Pallet Pricing',
            //     path: '/settings/palletPricing',
            // },
            {
                label: 'Static Pages',
                path: '/settings/static',
            },

            {
                label: 'Location',
                path: '/settings/location',
            },
            {
                label: 'General Settings',
                path: '/settings/general',
            },
            // {
            //     label: 'Maintanence',
            //     path: '/settings/maintanence',
            // },

            // {
            //     label: 'Bid Increments',
            //     path: '/settings/bid_increments',
            // },
            // {
            //     label: 'Tax Code',
            //     path: '/settings/tax_code',
            // },
            {
                label: 'Faq',
                path: '/settings/faq',
            },

            // {
            //     label: 'UI Settings',
            //     path: '/ui_settings',
            // },
            {
                label: 'Language Manager',
                path: '/languageManager',
            },
            // {
            //     label: 'Subscribers',
            //     path: '/subscribers',
            // },
            {
                label: 'Profile',
                path: '/profile',
            },
            {
                label: 'Change Password',
                path: '/change_password',
            },
            {
                label: 'Two Factor Authentication',
                path: '/settings/twoFactor',
            },
        ],
    },

    // {
    //     label: 'Video Auction',
    //     path: 'videoAuction',
    //     type: 'multiple',
    //     subLinks: [
    //         {
    //             label: 'Broadcast',
    //             path: '/videoAuction/broadcast',
    //         },
    //         {
    //             label: 'Live Auctions',
    //             path: '/videoAuction/live_auction',
    //         },
    //     ],
    // },

    {
        label: 'Employee',
        path: 'employees',
        type: 'multiple',
        subLinks: [
            {
                label: 'All',
                path: '/employees/all',
            },
        ],
    },

    // {
    //     label: 'My Billing Info',
    //     path: 'billing',
    //     type: 'multiple',
    //     subLinks: [
    //         {
    //             label: 'Payment',
    //             path: '/billing/all/0',
    //         },
    //         {
    //             label: 'Paid Invoice',
    //             path: '/billing/paid',
    //         },
    //         {
    //             label: 'Unpaid Invoice',
    //             path: '/billing/unpaid',
    //         },
    //     ],
    // },
    // {
    //     label: 'Template',
    //     type: 'multiple',
    //     path: 'templates',
    //     subLinks: [
    //         {
    //             label: 'Listing',
    //             path: '/templates/listing',
    //         },
    //         {
    //             label: 'Auction',
    //             path: '/templates/auction',
    //         },
    //     ],
    // },
    {
        label: 'Transactions',
        path: 'transaction',
        type: 'multiple',
        subLinks: [
            {
                label: 'Payment',
                path: '/transaction/payment',
            },
        ],
    },
    // {
    //     label: 'Return',
    //     path: 'return',
    //     type: 'multiple',
    //     subLinks: [
    //         // {
    //         //     label: 'Pending',
    //         //     path: '/return/pending',
    //         // },
    //         {
    //             label: 'Return Requested',
    //             path: '/return/requested',
    //         },
    //         {
    //             label: 'Completed',
    //             path: '/return/completed',
    //         },
    //         {
    //             label: 'Return Cancelled',
    //             path: '/return/cancelled',
    //         },
    //     ],
    // },
    // {
    //     label: 'Order Control',
    //     path: 'ordercontrol',
    //     type: 'multiple',
    //     subLinks: [
    //         {
    //             label: 'New',
    //             path: '/ordercontrol/new',
    //         },
    //         {
    //             label: 'In Transit',
    //             path: '/ordercontrol/intransit',
    //         },
    //         {
    //             label: 'Ready for Pickup',
    //             path: '/ordercontrol/pickup',
    //         },
    //         {
    //             label: 'Completed Order',
    //             path: '/ordercontrol/completed',
    //         },
    //         {
    //             label: 'Cancelled',
    //             path: '/ordercontrol/cancelled',
    //         },
    //         {
    //             label: 'Pending',
    //             path: '/ordercontrol/undelivered',
    //         },
    //         // {
    //         //     label: 'Delivered',
    //         //     path: '/ordercontrol/delivered',
    //         // },
    //     ],
    // },
    // {
    //     label: 'Inventory',
    //     path: 'inventory',
    //     type: 'multiple',
    //     subLinks: [
    //         {
    //             label: 'Add Inventory',
    //             path: '/inventory/add',
    //         },
    //         {
    //             label: 'Active Inventory',
    //             path: '/inventory/active',
    //         },
    //     ],
    // },
    {
        label: 'Logs',
        path: 'logs',
        type: 'multiple',
        subLinks: [
            {
                label: 'Email',
                path: '/logs/emailLogs',
            },
            // {
            //     label: 'SMS',
            //     path: '/logs/smsLogs',
            // },
        ],
    },
    // {
    //     label: 'Questions & Answers',
    //     path: '/questions_answers',
    //     type: 'single',
    //     showCount: true,
    //     count_name: 'noReplyCount',
    // },

    {
        label: 'Messages',
        path: '/messages',
        type: 'single',
    },
    {
        label: 'Pages',
        path: '/static',
        type: 'single',
    },

    // {
    //     label: 'Customer Activity',
    //     path: '/activity',
    //     type: 'single',
    // },
    // {
    //     label: 'Coupons List',
    //     path: '/registration_coupon',
    //     type: 'single',
    // },
    {
        label: 'Dynamic Pages',
        path: 'dynamic',
        type: 'multiple',
        subLinks: [
            {
                label: 'Dynamic Fields',
                path: '/dynamic/pages',
                type: 'single',
            },
            {
                label: 'Dynamic Tables',
                path: '/dynamic/table/pages',
                type: 'single',
            },
        ],
    },
]

export const ALL_PAGINATION = [
    {
        value: '20',
        show: '20 Results per page',
    },
    {
        value: '40',
        show: '40 Results per page',
    },
    {
        value: '60',
        show: '60 Results per page',
    },
]
